import '../styles/main.css'
import React, { ReactChild } from 'react';
import uuid from 'uuid/v4';

// import Pagination from './components/Pagination';
import Row from './components/Row';
import Visible from './components/Visible';
import { IMaterialDataTableProps, TValidContentTypes } from './prop-types';
import { reduceCells } from './shared';
import Table from './components/table/Table';
import TableBody from './components/table/TableBody';
import TableFooter from './components/table/TableFooter';
import TableRow from './components/table/TableRow';
import TableHead from './components/table/TableHead';
import { useToggle } from './hooks';
import Pagination from './components/Pagination';

export * from './prop-types';

export default function MaterialDataTable<C extends TValidContentTypes[]>(
  props: IMaterialDataTableProps<C>
) {
  const {
    title,
    rows,
    columnTitles,
    pagination,
    className = "",
    readOnly = false,
    tableProps,
    onRowCreate = () => null,
    onRowUpdate = () => null,
    onRowDelete = () => null
  } = props;
  const [isAddMode, toggleIsAddMode] = useToggle();

  const getColSpanLenght = () => {
    return readOnly ? columnTitles.length - 1 : columnTitles.length;
  };

  const getTableRows = () : ReactChild[] =>
    rows.map((r, i) => {
      const reducedcells = reduceCells(r.cells);
      if (reducedcells.length !== columnTitles.length) {
        throw new Error(
          "[Invalid Prop cells] cells[" +
            i +
            "] needs to have exactly " +
            columnTitles.length +
            " items in order to match the column titles, but contained " +
            r.cells.length
        );
      }

      return (
        <Row<C>
          key={r.id}
          {...r}
          onSave={onRowUpdate}
          onDelete={onRowDelete}
          readOnly={readOnly}
        />
      );
    });

  const getCreateRow = () : ReactChild => {
    return (
      <Row<C>
        {...rows[0]}
        onSave={r => {
          onRowCreate(r);
          toggleIsAddMode();
        }}
        readOnly={readOnly}
        onCancel={toggleIsAddMode}
        addMode
      />
    );
  };

  return (
    <div>
      <Table className={(className? className : "table")}>
        <TableHead
            title={title}
            columnTitles={columnTitles}
            colSpanLength={getColSpanLenght()}
            readOnly={readOnly}
            toggleIsAddMode={() => toggleIsAddMode()}
            {...tableProps} />
        <TableBody>
          <>{getTableRows()}</>
          <Visible if={isAddMode}>{getCreateRow()}</Visible>
        </TableBody>
        <>
          {pagination && (
            <Pagination
              readOnly={readOnly}
              currentPage={pagination.currentPage}
              currentPageSize={pagination.currentPageSize}
              colSpanLength={getColSpanLenght()}
              pageSizes={pagination.pageSizes}
              totalItemCount={pagination.totalCount}
              onChangePage={pagination.onChangePage}
              onChangePageSize={pagination.onChangePageSize}
            />
          )}
        </>
      </Table>
    </div>
  );
}
